import React, {FC, useMemo} from 'react';

import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {SimpleDropdown} from '../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown';
import {SimpleDropdownItem} from '../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdownItem';
import {PopoverTransferProps} from '../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {FilterDropdownBox} from '../../../../components/common/filters/filterDropdownBox/filterDropdownBox';
import {AnalyticsTableMetricColumn} from '../../../../models/api/analyticsMetricsModel';

/*
 * Props.
 */

interface ReportListAccessorDropdownProps {
  valueAccessors: ReadonlyArray<string>;
  selectedValueAccessor: string | undefined;
  onItemSelect: HandlerOf<string>;
  columns?: ReadonlyArray<AnalyticsTableMetricColumn>;
}

/*
 * Component.
 */

export const ReportListAccessorDropdown: FC<ReportListAccessorDropdownProps> = ({
  valueAccessors,
  selectedValueAccessor,
  onItemSelect,
  columns,
}) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const visibleMetrics = useMemo(
    () => columns?.filter((col) => valueAccessors.includes(col.id)) || [],
    [columns, valueAccessors],
  );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const selectedMetric = useMemo(
    () => columns?.find((col) => col.id === selectedValueAccessor),
    [columns, selectedValueAccessor],
  );

  if (valueAccessors.length <= 1) {
    return null;
  }

  const renderDropdown = (modalProps: PopoverTransferProps) => (
    <SimpleDropdown {...modalProps} width={180}>
      {visibleMetrics.map(({id, label}) => (
        <SimpleDropdownItem
          key={id}
          isChecked={selectedValueAccessor === id}
          onSelect={() => onItemSelect(id)}
        >
          {label}
        </SimpleDropdownItem>
      ))}
    </SimpleDropdown>
  );

  return <FilterDropdownBox renderButton={() => selectedMetric?.label} renderDropdown={renderDropdown} />;
};
